import { createContext, useContext, useState, useEffect } from "react";
import { auth } from "../firebase/config";
import { onAuthStateChanged } from "firebase/auth";
import { getUserById } from "../api/UserAPI";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUser(user);
        await getUserData(user);
      } else {
        setUser(null);
        setRole(null)
        localStorage.removeItem("userData")
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  async function getUserData(user) {
    user.getIdTokenResult()
      .then((idTokenResult) => {
        if (!!idTokenResult.claims.admin) {
          // Show admin UI.
          setRole('admin')
        } else {
          // Show regular user UI.
          setRole(null)
        }
      })
      .catch((error) => {
        console.log(error);
      });
    const res = await getUserById(user.uid)
    if (res.success) {
      localStorage.setItem("userData", JSON.stringify(res.userData))
    }
  }

  const reloadUser = async () => {
    if (auth.currentUser) {
      await auth.currentUser.reload();
      setUser({ ...auth.currentUser }); // Trigger UI re-render
      // await getUserData(auth.currentUser); // Optional: reload user data
    }
  };

  return <AuthContext.Provider value={{ user, role, reloadUser }}>
    {!loading && children}
  </AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);